import React from "react";

const DesktopFeatures = () => {
  return (
    <div id="desktop-features" className="row">
      <div className="col-4 position-relative mb-3">
        <div className="landing-feature-img-wrap offset-top">
          <img
            src="https://tbmcerts.s3.us-west-1.amazonaws.com/tbmcert-features-3.jpg"
            alt="Imagen 1"
            className="custom-height mw-100"
            style={{ borderRadius: "25px" }}
          />
          <div className="landing-feature-img-overlay" aria-hidden="true" style={{ borderRadius: "25px" }} />
        </div>
        <h5 className="landing-feature-heading h3 px-4 offset-top font-header text-white text-center">
          Emprende tu propio negocio
        </h5>
      </div>
      <div className="col-4 position-relative mt-3">
        <div className="landing-feature-img-wrap">
          <img
            src="https://tbmcerts.s3.us-west-1.amazonaws.com/tbmcert-features-2.jpg"
            alt="Imagen 2"
            className="mw-100 custom-height"
            style={{ borderRadius: "25px" }}
          />
          <div className="landing-feature-img-overlay" aria-hidden="true" style={{ borderRadius: "25px" }} />
        </div>
        <h5 className="landing-feature-heading h3 px-4 offset-top font-header text-white text-center">
          Amplía tus conocimientos
        </h5>
      </div>
      <div className="col-4 mb-3 position-relative">
        <div className="landing-feature-img-wrap offset-top">
          <img
            src="https://tbmcerts.s3.us-west-1.amazonaws.com/tbmcert-features-1.jpg"
            alt="Imagen 3"
            className="mw-100 custom-height"
            style={{ borderRadius: "25px" }}
          />
          <div className="landing-feature-img-overlay" aria-hidden="true" style={{ borderRadius: "25px" }} />
        </div>  
        <h5 className="landing-feature-heading h3 px-4 offset-top font-header text-white text-center">
          Mejora tu técnica
        </h5>
      </div>
    </div>
  );
};

export default DesktopFeatures;
